import React, { createContext, useEffect, useReducer } from "react";
import { dataUser } from "../utils/dataUser";

const initialLoginState = {
  isLoading: true,
  userName: null,
  userEmail: null,
  userToken: null,
  userId: null,
  userRole: null,
  signIn: () => null,
  signOut: () => null,
  signUp: () => null,
};

export const AuthContext = createContext(initialLoginState);

const loginReducer = (prevState, action) => {
  switch (action.type) {
    case "RETRIEVE_TOKEN":
      return {
        ...prevState,
        userName: action.username,
        userEmail: action.email,
        userToken: action.token,
        userId: action.userId,
        userRole: action.role,
        isLoading: false,
      };
    case "LOGIN":
      return {
        ...prevState,
        userName: action.username,
        userEmail: action.email,
        userToken: action.token,
        userId: action.userId,
        userRole: action.role,
        isLoading: false,
      };
    case "LOGOUT":
      return {
        ...prevState,
        userName: null,
        userEmail: null,
        userToken: null,
        userId: null,
        userRole: null,
        isLoading: false,
      };
    case "REGISTER":
      return {
        ...prevState,
        userName: action.username,
        userEmail: action.email,
        userToken: action.token,
        userId: action.userId,
        userRole: action.role,
        isLoading: false,
      };
    default:
      return {
        ...prevState,
        isLoading: false,
      };
  }
};

const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(loginReducer, initialLoginState);

  useEffect(() => {
    const currentToken = localStorage.getItem("userToken");
    const userToken =
      new Date(currentToken).toLocaleDateString() ===
      new Date().toLocaleDateString()
        ? currentToken
        : null;
    const userName = localStorage.getItem("userName");
    const userEmail = localStorage.getItem("userEmail");
    const userId = localStorage.getItem("userId");
    const userRole = localStorage.getItem("userRole");

    console.log(
      "retrieve token: ",
      `${userToken} ${userName} ${userEmail} ${userId} ${userRole}`
    );

    dispatch({
      type: "RETRIEVE_TOKEN",
      username: userName,
      email: userEmail,
      token: userToken,
      userId: Number(userId),
      role: userRole,
    });
  }, []);

  const signIn = async (emailLogin, password) => {
    try {
      const findUser = new Promise((resolve) => {
        const filtered = dataUser.filter((item) => item.email === emailLogin);

        resolve(filtered);
      });

      const response = await findUser;

      if (response.length === 0) {
        return Promise.reject("Email tidak terdaftar");
      }

      if (response[0].password !== password) {
        return Promise.reject("Password salah");
      }

      const { id, name, email, role } = response[0];
      const token = new Date().toISOString();

      dispatch({
        type: "LOGIN",
        username: name,
        email,
        token,
        userId: id,
        role,
      });

      localStorage.setItem("userToken", token);
      localStorage.setItem("userName", name);
      localStorage.setItem("userEmail", email);
      localStorage.setItem("userId", String(id));
      localStorage.setItem("userRole", role);

      return Promise.resolve(response[0]);
    } catch (err) {
      return Promise.reject(err);
    }
  };

  const signOut = () => {
    console.log("logout");
    try {
      localStorage.removeItem("userToken");
      localStorage.removeItem("userName");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("userId");
      localStorage.removeItem("userRole");
    } catch (err) {
      console.log(err);
    }

    dispatch({ type: "LOGOUT" });
  };

  const signUp = () => {};

  return (
    <AuthContext.Provider
      value={{
        ...state,
        signIn,
        signOut,
        signUp,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
